"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_external_contract_js_1 = require("@tableau/api-external-contract-js");
var TableauWorksheetEvent_1 = require("./TableauWorksheetEvent");
var SummaryDataChangedEvent = /** @class */ (function (_super) {
    __extends(SummaryDataChangedEvent, _super);
    function SummaryDataChangedEvent(worksheet) {
        return _super.call(this, api_external_contract_js_1.TableauEventType.SummaryDataChanged, worksheet) || this;
    }
    return SummaryDataChangedEvent;
}(TableauWorksheetEvent_1.TableauWorksheetEvent));
exports.SummaryDataChangedEvent = SummaryDataChangedEvent;
//# sourceMappingURL=SummaryDataChangedEvent.js.map